<template>
    <div id="HomeComponent" class="home-page">
        <NavBar />
        <main>
            <section class="home-hero" aria-labelledby="home-title">
                <b-container>
                    <b-row class="hero-row align-items-center">
                        <b-col lg="7" class="hero-copy">
                            <p class="eyebrow">Consultoría Oracle NetSuite en LATAM</p>
                            <h1 id="home-title" style="background: linear-gradient(90deg, #005afb, #290a69); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">Haz que NetSuite trabaje al ritmo de tu negocio</h1>
                            <p class="hero-lead">Consultoría especializada, desarrollos SuiteCloud y herramientas
                                conectadas a tu ERP para automatizar operaciones, fortalecer el control financiero y
                                cumplir con el SAT.</p>
                            <div class="hero-actions">
                                <a :href="whatsappUrl" class="btn-main" target="_blank" rel="noopener">Agendar
                                    diagnóstico <b-icon icon="arrow-up-right" /></a>
                                <a href="#soluciones" class="btn-quiet">Explorar soluciones <b-icon
                                        icon="arrow-down" /></a>
                            </div>
                            <ul class="proof-list">
                                <li><strong>10+</strong><span>años de experiencia</span></li>
                                <li><strong>98%</strong><span>satisfacción del cliente</span></li>
                                <li><b-icon icon="patch-check" /><span>Profesionales certificados en NetSuite</span>
                                </li>
                            </ul>
                        </b-col>
                        <b-col lg="5" class="visual-column">
                            <div class="ecosystem" aria-label="Ecosistema de soluciones conectado a Oracle NetSuite">
                                <span class="visual-label">ECOSISTEMA CONECTADO</span>
                                <img src="../assets/img/homepage/Diagrama CHBS.webp" alt="Oracle NetSuite conectado"
                                    class="ecosystem-diagram">

                                <span class="sync"><i></i> Sincronización activa</span>
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
            </section>

            <section class="tech-strip" aria-label="Tecnologías">
                <span>SuiteScript</span><i></i><span>SuiteTalk</span><i></i><span>SuiteAnalytics</span><i></i><span>CFDI
                    4.0</span><i></i><span>Integraciones API</span></section>

            <section id="soluciones" class="content-section solutions">
                <b-container>
                    <header class="split-heading">
                        <div><span class="kicker">SOLUCIONES PARA NETSUITE</span>
                            <h2>Más control. <span style="background: linear-gradient(90deg, #005afb, #290a69); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">Menos trabajo manual.</span></h2>
                        </div>
                        <p>Extendemos tu ERP con herramientas diseñadas alrededor de tus procesos, datos y obligaciones
                            fiscales.</p>
                    </header>
                    <NuestrosServicios />
                </b-container>
            </section>

            <section class="content-section results">
                <b-container>
                    <b-row class="align-items-end">
                        <b-col lg="5" class="results-copy"><span class="kicker">IMPACTO COMPROBADO</span>
                            <h2>Resultados que llegan a la operación</h2>
                            <p>Convertimos tareas repetitivas y controles dispersos en flujos trazables dentro del
                                ecosistema NetSuite.</p>
                        </b-col>
                        <b-col lg="7">
                            <div class="result-grid">
                                <article><strong>60<small>%</small></strong>
                                    <h3>menos trabajo manual</h3>
                                    <p>en el área financiera mediante un Validador XML y Portal de Proveedores.</p>
                                </article>
                                <article><strong>40<small>%</small></strong>
                                    <h3>menos trabajo de trazabilidad</h3>
                                    <p>de pedimentos asociados a facturas, reforzando el cumplimiento fiscal.</p>
                                </article>
                            </div>
                        </b-col>
                    </b-row>
                    <small class="result-note">Resultados de proyectos de clientes. El impacto varía según cada
                        operación.</small>
                </b-container>
            </section>

            <section class="content-section fiscal">
                <b-container><b-row class="align-items-center">
                        <b-col lg="5" class="fiscal-copy"><span class="kicker">CUMPLIMIENTO FISCAL EN MÉXICO</span>
                            <h2>Del CFDI a NetSuite, <span style="background: linear-gradient(90deg, #005afb, #290a69); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">sin procesos desconectados</span></h2>
                            <p>Centraliza recepción, validación, timbrado y trazabilidad fiscal con soluciones
                                compatibles con Oracle NetSuite.</p><router-link
                                to="/soluciones-fiscales-netsuite">Conocer soluciones fiscales <b-icon
                                    icon="arrow-right" /></router-link>
                        </b-col>
                        <b-col lg="7">
                            <div class="capability-grid">
                                <div v-for="item in capabilities" :key="item.title"><b-icon :icon="item.icon" />
                                    <p><strong>{{ item.title }}</strong><small>{{ item.text }}</small></p>
                                </div>
                            </div>
                        </b-col>
                    </b-row></b-container>
            </section>

            <section class="content-section process">
                <b-container>
                    <header class="center-heading"><span class="kicker">CÓMO TRABAJAMOS</span>
                        <h2>Especialistas que entienden el ERP y <span style="background: linear-gradient(90deg, #005afb, #290a69); -webkit-background-clip: text; -webkit-text-fill-color: transparent;">tu operación</span></h2>
                    </header>
                    <div class="process-grid">
                        <article v-for="(step, index) in process" :key="step.title"><span>0{{ index + 1 }}</span><b-icon
                                :icon="step.icon" />
                            <h3>{{ step.title }}</h3>
                            <p>{{ step.text }}</p>
                        </article>
                    </div>
                </b-container>
            </section>

            <section class="clients"><b-container>
                    <NuestrosClientes />
                </b-container></section>
            <section class="content-section"><b-container>
                    <CustomerReviews />
                </b-container></section>

            <section class="content-section faq"><b-container><b-row>
                        <b-col lg="4"><span class="kicker">PREGUNTAS FRECUENTES</span>
                            <h2>Antes de comenzar</h2>
                            <p>Respuestas para evaluar si somos el equipo adecuado para tu proyecto.</p>
                        </b-col>
                        <b-col lg="8">
                            <details v-for="(item, index) in faqs" :key="item.question" :open="index === 0">
                                <summary>{{ item.question }} <b-icon icon="plus" /></summary>
                                <p>{{ item.answer }}</p>
                            </details>
                        </b-col>
                    </b-row></b-container></section>

            <section class="conversion"><b-container>
                    <div>
                        <section><span>DIAGNÓSTICO INICIAL</span>
                            <h2>¿Qué proceso está frenando hoy a tu equipo?</h2>
                            <p>Cuéntanos el reto. Revisaremos cómo resolverlo dentro del ecosistema NetSuite.</p>
                        </section><a :href="whatsappUrl" class="btn-white" target="_blank" rel="noopener">Hablar con un
                            especialista <b-icon icon="whatsapp" /></a>
                    </div>
                </b-container></section>
            <section class="content-section contact"><b-container>
                    <header class="center-heading"><span class="kicker">CONTACTO</span>
                        <h2>Conversemos sobre tu operación</h2>
                    </header>
                    <ContactForm />
                </b-container></section>
        </main>
        <a :href="whatsappUrl" class="mobile-cta" target="_blank" rel="noopener"><b-icon icon="whatsapp" /> Agendar
            diagnóstico</a>
        <FooterChillByte />
    </div>
</template>

<script>
import NavBar from "../components/Template/NavBar.vue";
import NuestrosClientes from "../components/Homepage/NuestrosClientes.vue";
import CustomerReviews from "../components/Homepage/CustomerReviews.vue";
import Footer from "../components/Template/Footer.vue";
import ContactForm from "@/components/Template/ContactForm.vue";
import Servicios from "@/components/Homepage/Servicios.vue";

const SITE_URL = "https://www.chillbytesolutions.com";

export default {
    name: "HomeView",
    components: { NavBar, NuestrosClientes, CustomerReviews, FooterChillByte: Footer, ContactForm, NuestrosServicios: Servicios },
    data() {
        return {
            whatsappUrl: "https://api.whatsapp.com/send?phone=4423336440&text=Hola%2C%20quiero%20agendar%20un%20diagn%C3%B3stico%20para%20nuestra%20operaci%C3%B3n%20en%20NetSuite",
            capabilities: [
                { icon: "file-earmark-code", title: "Validador XML", text: "Verificación fiscal y de negocio" },
                { icon: "people", title: "Portal de Proveedores", text: "Recepción y seguimiento documental" },
                { icon: "receipt", title: "CFDI y complementos", text: "Timbrado, cancelación y addendas" },
                { icon: "truck", title: "Comercio Exterior", text: "Carta Porte y pedimentos" },
                { icon: "journal-check", title: "Contabilidad electrónica", text: "Información alineada al SAT" },
                { icon: "diagram-3", title: "Integración NetSuite", text: "Datos conectados con tu ERP" }
            ],
            process: [
                { icon: "search", title: "Diagnóstico", text: "Mapeamos el proceso, excepciones e impacto esperado." },
                { icon: "bounding-box", title: "Diseño", text: "Definimos arquitectura, alcance e integración." },
                { icon: "code-square", title: "Construcción", text: "Desarrollamos y validamos en ambiente controlado." },
                { icon: "headset", title: "Evolución", text: "Acompañamos la salida y mejora continua." }
            ],
            faqs: [
                { question: "¿Trabajan con empresas que ya utilizan Oracle NetSuite?", answer: "Sí. Nos especializamos en organizaciones con NetSuite activo que necesitan optimizar procesos, desarrollar capacidades, integrar sistemas o resolver requerimientos fiscales de México." },
                { question: "¿Sus herramientas se conectan directamente con NetSuite?", answer: "Sí. Diseñamos cada integración con las capacidades de SuiteCloud y APIs disponibles para mantener datos y procesos sincronizados." },
                { question: "¿Pueden adaptar una solución a nuestros procesos?", answer: "Sí. Analizamos el flujo y sus excepciones antes de configurar o desarrollar una solución compatible con la operación de cada empresa." },
                { question: "¿Atienden requerimientos fiscales de México?", answer: "Sí. Cubrimos CFDI, complementos, addendas, cancelación, Comercio Exterior, Carta Porte, contabilidad electrónica, validación XML y gestión de proveedores." }
            ]
        };
    },
    metaInfo() {
        const title = "Consultoría Oracle NetSuite en México | Chill Byte Solutions";
        const description = "Consultoría Oracle NetSuite, SuiteCloud, POS, conciliación bancaria y soluciones fiscales CFDI para empresas en México.";
        const faqSchema = { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: this.faqs.map(item => ({ "@type": "Question", name: item.question, acceptedAnswer: { "@type": "Answer", text: item.answer } })) };
        const serviceSchema = { "@context": "https://schema.org", "@type": "ProfessionalService", name: "Chill Byte Solutions", url: SITE_URL, areaServed: "MX", description, knowsAbout: ["Oracle NetSuite", "SuiteCloud", "CFDI 4.0", "Integraciones ERP"] };
        return {
            title, link: [{ rel: "canonical", href: `${SITE_URL}/` }], meta: [
                { vmid: "description", name: "description", content: description }, { vmid: "robots", name: "robots", content: "index,follow,max-image-preview:large,max-snippet:-1" },
                { vmid: "og:type", property: "og:type", content: "website" }, { vmid: "og:locale", property: "og:locale", content: "es_MX" }, { vmid: "og:title", property: "og:title", content: title }, { vmid: "og:description", property: "og:description", content: description }, { vmid: "og:url", property: "og:url", content: `${SITE_URL}/` },
                { vmid: "twitter:card", name: "twitter:card", content: "summary_large_image" }, { vmid: "twitter:title", name: "twitter:title", content: title }, { vmid: "twitter:description", name: "twitter:description", content: description }
            ], script: [
                { vmid: "home-service-schema", type: "application/ld+json", innerHTML: JSON.stringify(serviceSchema) }, { vmid: "home-faq-schema", type: "application/ld+json", innerHTML: JSON.stringify(faqSchema) }
            ], __dangerouslyDisableSanitizersByTagID: { "home-service-schema": ["innerHTML"], "home-faq-schema": ["innerHTML"] }
        };
    }
};
</script>

<style scoped lang="scss">
$ink: #101828;
$muted: #475467;
$line: #dbe3ee;
$blue: #146ef5;
$deep: #073b8c;
$surface: #f4f7fb;

.home-page {
    color: $ink;
    background: #fff;
    letter-spacing: 0
}

.home-hero {
    position: relative;
    overflow: hidden;
    background: #f7f9fc;
    border-bottom: 1px solid $line
}

.home-hero:before {
    content: "";
    position: absolute;
    inset: 0;
    background-image: linear-gradient(rgba(20, 110, 245, .05) 1px, transparent 1px), linear-gradient(90deg, rgba(20, 110, 245, .05) 1px, transparent 1px);
    background-size: 48px 48px;
    mask-image: linear-gradient(to right, #000, transparent 78%)
}

.hero-row {
    position: relative;
    min-height: 690px;
    padding: 70px 0
}

.hero-copy {
    padding-right: 50px
}

.eyebrow,
.kicker {
    color: $deep;
    font-size: .76rem;
    font-weight: 800;
    letter-spacing: .12em;
    text-transform: uppercase;
    margin-bottom: 20px
}

.hero-copy h1 {
    color: $ink !important;
    font-size: clamp(3.2rem, 5.1vw, 4.9rem) !important;
    font-weight: 800;
    line-height: .99;
    margin: 0 0 26px;
    padding-bottom: 20px;
}

.hero-lead {
    max-width: 680px;
    color: $muted;
    font-size: 1.2rem;
    line-height: 1.7;
}

.hero-actions {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    margin-top: 32px
}

.btn-main,
.btn-quiet,
.btn-white {
    min-height: 52px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 13px 22px;
    border-radius: 6px;
    font-weight: 750;
    text-decoration: none
}

.btn-main {
    color: #fff;
    background: $blue;
    box-shadow: 0 12px 28px rgba(20, 110, 245, .23)
}

.btn-main:hover {
    color: #fff;
    background: #075fdc;
    text-decoration: none
}

.btn-quiet {
    color: $ink;
    background: #fff;
    border: 1px solid #cbd5e1
}

.btn-quiet:hover {
    color: $blue;
    text-decoration: none
}

.proof-list {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 42px 0 0
}

.proof-list li {
    min-height: 52px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 20px;
    border-left: 1px solid $line
}

.proof-list li:first-child {
    padding-left: 0;
    border: 0
}

.proof-list strong {
    font-size: 1.45rem;
    line-height: 1
}

.proof-list span {
    max-width: 165px;
    color: $muted;
    font-size: .76rem
}

.proof-list svg {
    color: $blue;
    width: 24px;
    height: 24px
}

.visual-column {
    display: flex;
    justify-content: center
}

.ecosystem {
    position: relative;
    width: 430px;
    height: 450px;
    display: flex;
    align-items: center;
    justify-content: center
}

.visual-label {
    position: absolute;
    top: 15px;
    left: 50%;
    transform: translateX(-50%);
    color: #667085;
    font-size: .68rem;
    font-weight: 800;
    letter-spacing: .14em;
    white-space: nowrap;
}

.ecosystem-diagram {
    display: block;
    width: min(350px, 100%);
    height: auto;
    max-height: 350px;
    object-fit: contain;
    margin-top: 15px;
}

.pos {
    left: 0;
    top: 90px
}

.pos:after {
    left: 100%;
    top: 35px;
    transform: rotate(28deg);
    transform-origin: left
}

.bank {
    right: 0;
    top: 115px
}

.bank:after {
    right: 100%;
    top: 32px;
    transform: rotate(-25deg);
    transform-origin: right
}

.tax {
    left: 18px;
    bottom: 65px
}

.tax:after {
    left: 100%;
    bottom: 25px;
    transform: rotate(-28deg);
    transform-origin: left
}

.sync {
    position: absolute;
    right: 12px;
    bottom: 25px;
    color: #12805c;
    font-size: .72rem;
    font-weight: 750
}

.sync i {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #12a679;
    box-shadow: 0 0 0 5px rgba(18, 166, 121, .12)
}

.tech-strip {
    min-height: 64px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 20px;
    color: #667085;
    font-size: .72rem;
    font-weight: 750;
    letter-spacing: .08em;
    text-transform: uppercase;
    border-bottom: 1px solid $line
}

.tech-strip i {
    width: 3px;
    height: 3px;
    border-radius: 50%;
    background: #98a2b3
}

.content-section {
    padding: 105px 0
}

.solutions {
    background: #fff
}

.split-heading {
    display: grid;
    grid-template-columns: 1.2fr .8fr;
    align-items: end;
    gap: 70px;
    margin-bottom: 52px
}

.split-heading h2,
.center-heading h2,
.fiscal h2,
.faq h2 {
    color: $ink;
    font-size: clamp(2.15rem, 4vw, 3.25rem);
    font-weight: 800;
    line-height: 1.08;
    margin: 0
}

.split-heading>p,
.fiscal-copy>p,
.faq p {
    color: $muted;
    font-size: 1.05rem;
    line-height: 1.7
}

.results {
    color: #fff;
    background: #0c1b33
}

.results .kicker {
    color: #68d8ec
}

.results h2 {
    color: #fff;
    font-size: clamp(2.2rem, 4vw, 3.3rem);
    font-weight: 800;
    line-height: 1.08
}

.results-copy>p {
    color: #b9c5d8;
    font-size: 1.05rem;
    line-height: 1.7
}

.result-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 18px
}

.result-grid article {
    min-height: 275px;
    padding: 30px;
    border: 1px solid rgba(255, 255, 255, .14);
    border-radius: 8px;
    background: rgba(255, 255, 255, .05)
}

.result-grid strong {
    display: block;
    color: #67d6ea;
    font-size: 4.3rem;
    line-height: 1;
    margin-bottom: 22px
}

.result-grid strong small {
    font-size: 2rem
}

.result-grid h3 {
    color: #fff;
    font-size: 1.18rem;
    font-weight: 750
}

.result-grid p {
    color: #b9c5d8;
    line-height: 1.6
}

.result-note {
    display: block;
    color: #8191aa;
    text-align: right;
    margin-top: 26px
}

.fiscal,
.faq,
.clients {
    background: $surface
}

.fiscal-copy {
    padding-right: 50px
}

.fiscal-copy h2 {
    margin-bottom: 22px
}

.fiscal-copy a {
    display: inline-flex;
    gap: 8px;
    align-items: center;
    color: $blue;
    font-weight: 800;
    margin-top: 12px
}

.capability-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    background: #fff;
    border: 1px solid $line;
    border-radius: 8px;
    box-shadow: 0 22px 60px rgba(16, 24, 40, .08)
}

.capability-grid>div {
    min-height: 115px;
    display: flex;
    gap: 15px;
    padding: 23px;
    border-right: 1px solid $line;
    border-bottom: 1px solid $line
}

.capability-grid>div:nth-child(2n) {
    border-right: 0
}

.capability-grid>div:nth-last-child(-n+2) {
    border-bottom: 0
}

.capability-grid svg {
    color: $blue;
    width: 22px;
    height: 22px
}

.capability-grid p {
    display: flex;
    flex-direction: column;
    margin: 0
}

.capability-grid small {
    color: $muted;
    margin-top: 5px
}

.center-heading {
    max-width: 720px;
    text-align: center;
    margin: 0 auto 50px
}

.process-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    border-block: 1px solid $line
}

.process-grid article {
    position: relative;
    min-height: 250px;
    padding: 30px 26px;
    border-right: 1px solid $line
}

.process-grid article:last-child {
    border: 0
}

.process-grid article>span {
    position: absolute;
    right: 17px;
    top: 17px;
    color: #d0d5dd;
    font-family: monospace
}

.process-grid svg {
    width: 27px;
    height: 27px;
    color: $blue;
    margin-bottom: 38px
}

.process-grid h3 {
    font-size: 1.15rem;
    font-weight: 800
}

.process-grid p {
    color: $muted;
    line-height: 1.6
}

.clients {
    padding: 60px 0
}

.faq h2 {
    margin-bottom: 15px
}

.faq details {
    border-top: 1px solid #cbd5e1
}

.faq details:last-child {
    border-bottom: 1px solid #cbd5e1
}

.faq summary {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 23px 4px;
    font-weight: 800;
    cursor: pointer;
    list-style: none
}

.faq details p {
    padding: 0 45px 23px 4px;
    margin: 0
}

.faq details[open] summary svg {
    transform: rotate(45deg)
}

.conversion {
    padding: 70px 0;
    color: #fff;
    background: $blue
}

.conversion .container>div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 35px
}

.conversion section {
    max-width: 720px
}

.conversion section>span {
    font-size: .72rem;
    font-weight: 800;
    letter-spacing: .13em
}

.conversion h2 {
    color: #fff;
    font-size: clamp(2rem, 3.5vw, 3rem);
    font-weight: 800;
    margin: 10px 0
}

.conversion p {
    color: rgba(255, 255, 255, .86);
    margin: 0
}

.btn-white {
    flex: 0 0 auto;
    color: $deep;
    background: #fff
}

.contact {
    background: #fff
}

.mobile-cta {
    display: none
}

@media(max-width:991px) {
    .hero-row {
        min-height: auto
    }

    .hero-copy {
        padding-right: 15px
    }

    .visual-column {
        margin-top: 50px
    }

    .split-heading {
        grid-template-columns: 1fr;
        gap: 15px
    }

    .results-copy,
    .fiscal-copy {
        margin-bottom: 40px
    }

    .fiscal-copy {
        padding-right: 15px
    }

    .process-grid {
        grid-template-columns: repeat(2, 1fr)
    }

    .process-grid article:nth-child(2) {
        border-right: 0
    }

    .process-grid article:nth-child(-n+2) {
        border-bottom: 1px solid $line
    }

    .conversion .container>div {
        align-items: flex-start;
        flex-direction: column
    }
}

@media(max-width:575px) {
    .hero-row {
        padding: 55px 0 40px
    }

    .hero-copy h1 {
        font-size: 2.65rem !important;
        line-height: 1.2;
    }

    .hero-lead {
        font-size: 1.02rem
    }

    .hero-actions {
        flex-direction: column
    }

    .hero-actions a {
        width: 100%
    }

    .proof-list {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        row-gap: 18px
    }

    .proof-list li {
        padding: 0 12px
    }

    .proof-list li:nth-child(3) {
        grid-column: 1/-1;
        border: 0;
        padding-left: 0
    }

    .ecosystem {
        width: 100%;
        height: 400px;
        transform: scale(.91)
    }

    .content-section {
        padding: 65px 0
    }

    .result-grid,
    .capability-grid,
    .process-grid {
        grid-template-columns: 1fr
    }

    .result-grid article {
        min-height: 225px
    }

    .result-note {
        text-align: left
    }

    .capability-grid>div {
        border-right: 0
    }

    .capability-grid>div:nth-last-child(2) {
        border-bottom: 1px solid $line
    }

    .process-grid article {
        min-height: 210px;
        border-right: 0 !important;
        border-bottom: 1px solid $line
    }

    .conversion {
        padding: 55px 0 90px
    }

    .btn-white {
        width: 100%
    }

    .mobile-cta {
        position: fixed;
        z-index: 1000;
        left: 12px;
        right: 12px;
        bottom: 12px;
        min-height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        color: #fff;
        background: #087f5b;
        border-radius: 6px;
        font-weight: 800;
        box-shadow: 0 12px 30px rgba(0, 0, 0, .25)
    }

    .mobile-cta:hover {
        color: #fff;
        text-decoration: none
    }
}

@media(prefers-reduced-motion:reduce) {
    * {
        scroll-behavior: auto !important;
        transition: none !important;
        animation: none !important
    }
}
</style>